var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{ref:"iframe",staticStyle:{"border":"none","width":"100%","height":"calc(100vh - 72px)"},attrs:{"src":_vm.route('logistics.gantt')}})
}
var staticRenderFns = []

export { render, staticRenderFns }